import { JSX } from 'react';
import { Alert, Done, Error, Info, Warning } from '../../icons';
import { Severity } from '../../types';
import { Loader } from '../Loader';

interface ToastIconProps {
  severity: Severity;
}

export const NotificationToastIcon = ({ severity }: ToastIconProps) => {
  const iconMap: Record<Severity, JSX.Element> = {
    success: <Done className="text-secondary size-4" />,
    error: <Error className="text-accent-pink size-4" />,
    warning: <Warning className="text-warning size-4" />,
    info: <Info className="text-primary size-4" />,
    alert: <Alert className="text-primary size-4" />,
    loading: <Loader className="text-primary size-4" />,
  };

  return iconMap[severity] || null;
};
